import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { useEffect, useState } from 'react';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

import Spinner from '@/components/Spinner';

import ImageLoader from '@/ImageLoader';
import { loginRequest } from '@/authConfig';
import komatsuLogo from '@/public/KomatsuLogo.svg';
import kaiwaLogo from '@/public/kaiwaLogo.svg';
import microsoftLogo from '@/public/microsoft.svg';

const LoadingComponent = () => {
  return (
    <div className="loading">
      <Spinner size="28px" className="mx-auto" />
      <h2>Loading....</h2>
    </div>
  );
};

let callPush = true;
const Login = () => {
  const { instance } = useMsal();
  const router = useRouter();

  const handleLoginRedirect = async () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };
  const handleLoginSuccess = () => {
    router.push('/home');
    callPush = false;
  };
  if (instance) {
    const activeAccount = instance.getActiveAccount();
    if (activeAccount && callPush) {
      handleLoginSuccess();
    }
  }

  return (
    <div className="loginBackgroundPage">
      {instance.getActiveAccount() ? (
        <AuthenticatedTemplate>
          <LoadingComponent />
        </AuthenticatedTemplate>
      ) : (
        <UnauthenticatedTemplate>
          <div className="loginPageAlign">
            <Image
              src={kaiwaLogo}
              alt="KAIWA"
              width="100"
              height="100"
              className="KAIWA_logo"
            />
            <h1
              style={{
                fontWeight: 600,
                marginTop: '25px',
                marginBottom: '5px',
              }}
            >
              Komatsu AI Web Assistant
            </h1>
            <h4> Connect with your Microsoft account</h4>
            <button className="loginButton" onClick={handleLoginRedirect}>
              Sign In
            </button>
          </div>
          <div className="komatsuLogo">
            <Link href="/">
              <Image src={komatsuLogo} alt="Komatsu" width="120" height="120" />
            </Link>
          </div>
        </UnauthenticatedTemplate>
      )}
    </div>
  );
};

export default Login;
